// extracted by mini-css-extract-plugin
module.exports = {"outer":"_8qx7a","heading":"_2a7dT","subHeading":"zlQ8j"};